import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import { saveBrand } from "../../redux/actions";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import AddTopicModal from "./components/AddTopicModal";
import AddPerkModal from "./components/AddPerkModal";
import AddTaskModal from "./components/AddTaskModal";
import AddVideoModal from "./components/AddVideoModal";
import AddEventModal from "../Event/AddEventModal";
import "./index.css";
import topicImg from "../../assets/media/xmas/topic.png";
import perkImg from "../../assets/media/xmas/santa-claus.png";
import taskImg from "../../assets/media/xmas/task.png";
import videoImg from "../../assets/media/xmas/video.png";

import plugImg from "../../assets/media/plus.png";
import checkImg from "../../assets/media/check.png";
import eventImg from "../../assets/media/ticket.png";

import { TerritoryOptions } from "../../Constants/retailer";
import { getYoutubeId } from "../../Utils/utils";
import {
  GIF_UPLOAD,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";
const $ = window.$;

class AdventPlanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      loading: false,
      loading_script: "",
      postData: null,
      posts: [],
      users: [],
      polls: [],
      competitions: [],
      retailers: [],
      offers: [],
      selectedWeek: 0,
      selectedDate: null,
      hotTopics: [],
      current_hotTopic: null,
      topics: [],
      perks: [],
      tasks: [],
      videos: [],
      events: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        brand_data.id = brand;
        this.props.dispatch(saveBrand(brand_data));
        this.setState(
          {
            logo: brand_data.logo,
            icon: brand_data.icon,
            brand_name: brand_data.name,
            brand_url: brand_data.url,
            territory: brand_data.territory || TerritoryOptions[0],
            hex: brand_data.hex,
            is_property_brand: brand_data.is_property_brand
              ? brand_data.is_property_brand
              : false,
          },
          () => {
            Firebase.getAllDailyTopics(brand_data.name, (topics) =>
              this.setState({ topics })
            );
            Firebase.getAllDailyPerks(brand_data.name, (perks) =>
              this.setState({ perks })
            );
            Firebase.getAllDailyTasks(brand_data.name, (tasks) =>
              this.setState({ tasks })
            );
            Firebase.getAllDailyVideos(brand_data.name, (videos) =>
              this.setState({ videos })
            );
            Firebase.getAllDailyEvents(brand_data.name, (events) =>
              this.setState({ events })
            );
          }
        );
      });
    }
  }

  showPlans = (type = "topic") => {
    let PlanItem = ({ date }) => {
      let image = null,
        youtube_video = null,
        video = null,
        text = "";
      let resObj = null;
      if (type === "topic") {
        resObj = this.state.topics.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
      } else if (type === "perk") {
        resObj = this.state.perks.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
      } else if (type === "task") {
        resObj = this.state.tasks.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
      } else if (type === "video") {
        resObj = this.state.videos.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
      } else if (type === "event") {
        resObj = this.state.events.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
      }
      image =
        resObj &&
        (resObj.media_type === IMAGE_UPLOAD || resObj.media_type === GIF_UPLOAD)
          ? resObj.media_url
          : null;
      youtube_video =
        resObj && resObj.media_type === YOUTUBE_URL ? resObj.media_url : null;
      video =
        resObj && resObj.media_type === VIDEO_UPLOAD ? resObj.media_url : null;
      image = resObj && type === "perk" ? resObj.logo : image;
      text = image || youtube_video || video ? "" : resObj ? resObj.title : "";
      if (text) {
        return (
          <div className="calendar-item col-div-center">
            <p className="letters">{text}</p>
          </div>
        );
      }
      if (image) {
        return (
          <div
            style={{ backgroundImage: `url(${image})` }}
            className="calendar-item"
          >
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (video) {
        return (
          <div className="calendar-item">
            <ReactPlayer
              url={video}
              width="100%"
              height="100%"
              controls={true}
            />
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (youtube_video) {
        return (
          <div className="calendar-item">
            <iframe
              title="video"
              width="100%"
              height="100%"
              src={`//www.youtube.com/embed/${getYoutubeId(
                youtube_video
              )}?modestbranding=1&showinfo=0`}
              frameBorder="0"
              allowFullScreen
            ></iframe>
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      const isPastDay = date.isBefore(moment(), "day");
      return (
        <button
          className="add-plan-btn"
          type="button"
          data-toggle="modal"
          data-target={`${
            type === "event"
              ? "#add_event_modal"
              : "#add_daily_" + type + "_modal"
          }`}
          onClick={() => {
            this.setState({ selectedDate: date });
          }}
          disabled={isPastDay}
        >
          {!isPastDay && (
            <img src={plugImg} className="default-item" alt="default" />
          )}
        </button>
      );
    };

    return [0, 1, 2, 3, 4, 5, 6].map((i) => (
      <div key={i} className="plan">
        <PlanItem date={this.getWeekDate(i)} />
      </div>
    ));
  };

  getWeekDate = (i) => {
    const xmas = moment("28/11/2021", "DD/MM/YYYY");
    // if (moment().isSame(moment().startOf("week"))) {
    //   return moment().add("days", this.state.selectedWeek * 7 + i - 6);
    // }
    return xmas.startOf("week").add("days", this.state.selectedWeek * 7 + i);
  };

  showDays = () => {
    return [0, 1, 2, 3, 4, 5, 6].map((item, index) => {
      const date = this.getWeekDate(index);
      return (
        <p key={index} style={{ width: "13%" }}>
          D{item + 1} - {date.format("DD[th] MMM")}
        </p>
      );
    });
  };

  showWeekBar = () => {
    const { selectedWeek } = this.state;
    return (
      <div className="week-bar">
        {[0, 1, 2, 3].map((obj) => (
          <button
            key={obj}
            className={`btn week_btn ${selectedWeek === obj ? "active" : ""}`}
            onClick={() => {
              this.setState({ selectedWeek: obj }, this.getHotTopic);
            }}
          >
            Week {obj + 1}
          </button>
        ))}
      </div>
    );
  };
  createPlan = (type) => (content) => {
    content.time = this.state.selectedDate.toDate();
    if (type === "topic")
      Firebase.addDailyTopic(content, this.state.brand_name);
    if (type === "perk") {
      Firebase.addDailyPerk(content, this.state.brand_name);
    }
    if (type === "task") {
      Firebase.addDailyTask(content, this.state.brand_name);
    }
    if (type === "video") {
      Firebase.addDailyVideo(content, this.state.brand_name);
    }
    if (type === "event") {
      Firebase.addDailyEvent(content, this.state.brand_name);
    }
  };
  createEvent = async (payload) => {
    const {
      img_content,
      title,
      address,
      token,
      type,
      description,
      selectedDate,
    } = payload;
    let { brand_name } = this.state;
    let folder = "events/" + brand_name;
    this.setState({ loading: true });
    let image_url = await Firebase.uploadImage(img_content, title, folder);
    let event = {
      title,
      type,
      address,
      description,
      image_url,
      token,
      time: selectedDate.toDate(),
    };
    Firebase.addDailyEvent(event, this.state.brand_name);
  };
  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      loading_script,
      brand_name,
      territory,
    } = this.state;
    return (
      <div id="advent_planner-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" className="advent_planner-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
              <p>{loading_script}</p>
            </div>
          )}
          {this.showWeekBar()}
          <div className="calendar">
            <div className="date">
              <p style={{ width: "9%" }}></p>
              {this.showDays()}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{ backgroundColor: "#FAFF87" }}
              >
                <img src={topicImg} alt="Topic" />
                <p>Topic</p>
              </div>
              {this.showPlans("topic")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{ backgroundColor: "#d5ffc6" }}
              >
                <img src={perkImg} alt="Perk" />
                <p>Perk</p>
              </div>
              {this.showPlans("perk")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{ backgroundColor: "#ffcfff" }}
              >
                <img src={taskImg} alt="Task" />
                <p>Task</p>
              </div>
              {this.showPlans("task")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{ backgroundColor: "#daf6ff" }}
              >
                <img src={videoImg} alt="Video" />
                <p>Video</p>
              </div>
              {this.showPlans("video")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{ backgroundColor: "#C7B1FF" }}
              >
                <img src={eventImg} alt="Event" />
                <p>Events</p>
              </div>
              {this.showPlans("event")}
            </div>
          </div>
          <AddTopicModal onCreate={this.createPlan("topic")} />
          <AddPerkModal
            onCreate={this.createPlan("perk")}
            territory={territory}
          />
          <AddTaskModal onCreate={this.createPlan("task")} />
          <AddVideoModal onCreate={this.createPlan("video")} />
          <AddEventModal
            selectedDate={this.state.selectedDate}
            createEvent={this.createEvent}
            territory={territory}
          />
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
    unreads: state.unreads,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AdventPlanner);



// WEBPACK FOOTER //
// ./src/screens/AdventPlanner/index.js